import React, { Component } from 'react';
import styled from 'styled-components';
import TagService from '../../services/TagService';
import OLink from '../../orange-ui/components/Link/OLink';
import WordingService from '../../services/WordingService';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  margin-top: 2.125rem;
  margin-bottom: 4.8rem;
`;

class Help extends Component {
  render() {
    const { isFirstConnection } = this.props;

    const link = window.reactAppEnv.features.firstConnection && isFirstConnection === true ? window.reactAppEnv.href.helpFirstConnection : window.reactAppEnv.href.help;

    return (
      <Wrapper>
        <OLink href={link} id="help-link" onClick={() => TagService.sendAction('assistance')} newTab={true} underline={false} children={WordingService.getWording('url', 'helpLabel')} title={WordingService.getWording('url', 'helpLabel')} />
      </Wrapper>
    );
  }
}

Help.propTypes = {
  identities: PropTypes.shape(),
  isFirstConnection: PropTypes.bool,
};

Help.defaultProps = {
  identities: {},
  isFirstConnection: false,
};

export default Help;
